module.exports = __webpack_public_path__ + "static/media/avatar.5b478440.png";